
    <button
      *ngFor="let organization of organizations"
      (click)="select(organization)"
    >
      {{ organization.identifier }}
    </button>
  